import IconButton from '#components/controls/icon-button/IconButton';
import Close from 'src/components/icons/Close';
import Typography from '#components/typography/Typography';

type Props = {
  title?: string;
  onClose: () => void;
};

const DialogHeader = ({ title, onClose }: Props) => {
  return (
    <>
      <div
        className="tw-absolute tw-top-2 tw-right-2 medium-up:tw-top-8 medium-up:tw-right-8"
        data-testid="close-overlay"
      >
        <IconButton onClick={onClose} transparent={true}>
          <Close size={40} />
        </IconButton>
      </div>
      {!!title && (
        <Typography
          classes="tw-text-center tw-mb-6 tw-text-3xl medium:tw-text-4xl large:tw-text-6xl medium:tw-mb-12"
          color="secondary"
          effect="gradient"
        >
          {title}
        </Typography>
      )}
    </>
  );
};

export default DialogHeader;
